/**
 * Enhanced Smooth Scroll Friction
 * For Shopify Fluorescent Stiletto Theme
 * Mimics Benetti Yachts (www.benettiyachts.com) scroll behavior
 * Deactivated on mobile devices
 * Fixed for quick-cart.liquid and search compatibility
 */
document.addEventListener('DOMContentLoaded', () => {
  // Mobile detection
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;
  
  // Exit early if on mobile device
  if (isMobile) {
    console.debug('Smooth scroll deactivated on mobile device');
    return;
  }
  
  // DRAWER FIX: Function to check if element is in the quick cart or search
  function isInDrawer(element) {
    if (!element) return false;
    
    // Check current element and all parent elements
    let current = element;
    while (current && current !== document.body && current !== document.documentElement) {
      if (current.classList && (
        // Quick cart selectors
        current.classList.contains('quick-cart') ||
        current.closest('.quick-cart') ||
        current.id === 'quick-cart' ||
        current.hasAttribute('data-quick-cart') ||
        (current.classList.contains('drawer') && current.querySelector('.quick-cart')) ||
        // Search selectors - using broader search terms
        current.classList.contains('search') ||
        current.closest('.search') ||
        current.id === 'search' ||
        current.id === 'Search' ||
        current.classList.contains('quick-search') ||
        current.classList.contains('search-drawer') ||
        current.hasAttribute('data-search') ||
        current.hasAttribute('data-search-drawer') ||
        current.hasAttribute('data-predictive-search') ||
        (current.classList.contains('drawer') && current.querySelector('.search')) ||
        // Input elements within search
        (current.tagName === 'INPUT' && current.type === 'search') ||
        (current.querySelector && current.querySelector('input[type="search"]'))
      )) {
        return true;
      }
      current = current.parentElement;
    }
    return false;
  }
  
  // Core variables
  let currentY = window.scrollY;
  let targetY = window.scrollY;
  let frameId = null;
  let lastScrollTime = 0;
  let scrollDirection = 0;
  let touchStartY = 0;
  let isTouching = false;
  let velocity = 0;
  
  // Configuration - fine-tuned for more natural feel
  const config = {
    friction: 0.5,       // Adjusted for more natural resistance
    acceleration: 0.6,     // Slightly higher acceleration for more responsive feel
    touchMultiplier: 1.8,  // Enhanced touch sensitivity
    minDelta: 0.05,        // Lower threshold for smoother stops
    maxDelta: 80,          // Reduced max delta for more controlled motion
    easeFactor: 0.03,      // Enhanced easing for smoother direction changes
    velocityFactor: 0.85,  // Velocity retention factor
    dampingThreshold: 15,  // Threshold for applying additional damping
    dampingFactor: 0.4     // How much to dampen rapid direction changes
  };
  
  // Track performance
  let lastFrameTime = performance.now();
  let slowFrameCount = 0;
  
  // Performance optimizer - reduces friction on slow devices
  function optimizeForPerformance() {
    const now = performance.now();
    const frameTime = now - lastFrameTime;
    lastFrameTime = now;
    
    // If we detect slow frames, adjust friction to be faster/less smooth
    if (frameTime > 25) { // 40fps threshold
      slowFrameCount++;
      if (slowFrameCount > 5 && config.friction < 0.15) {
        config.friction += 0.01;
        console.debug('Adjusting friction for performance:', config.friction);
        slowFrameCount = 0;
      }
    } else {
      slowFrameCount = Math.max(0, slowFrameCount - 1);
    }
  }
  
  // Handle mouse wheel scroll events
  window.addEventListener('wheel', (e) => {
    // DRAWER FIX: Skip handling if the event is within the quick cart or search
    if (isInDrawer(e.target)) {
      return; // Let default browser handling work for drawers
    }
    
    e.preventDefault();
    
    // Calculate scroll direction for natural easing
    const currentDirection = Math.sign(e.deltaY);
    
    // Apply velocity-based scrolling for more natural feel
    if (currentDirection !== scrollDirection && scrollDirection !== 0) {
      // Direction changed, apply enhanced damping
      velocity *= -config.dampingFactor; // Apply damping when changing direction
      targetY += (e.deltaY * config.acceleration * config.easeFactor);
    } else {
      // Same direction, calculate velocity contribution
      velocity = velocity * config.velocityFactor + (e.deltaY * config.acceleration);
      targetY += e.deltaY * config.acceleration;
    }
    
    scrollDirection = currentDirection;
    lastScrollTime = performance.now();
    
    // Clamp to valid scroll range
    targetY = Math.max(0, Math.min(targetY, 
      document.documentElement.scrollHeight - window.innerHeight));
    
    if (!frameId) {
      frameId = requestAnimationFrame(render);
    }
  }, { passive: false });
  
  // Handle touch events for mobile
  window.addEventListener('touchstart', (e) => {
    // DRAWER FIX: Skip handling if the event is within the quick cart or search
    if (isInDrawer(e.target)) {
      return;
    }
    
    isTouching = true;
    touchStartY = e.touches[0].clientY;
    velocity = 0; // Reset velocity on new touch
  }, { passive: true });
  
  window.addEventListener('touchmove', (e) => {
    // DRAWER FIX: Skip handling if the event is within the quick cart or search
    if (isInDrawer(e.target)) {
      return;
    }
    
    if (!isTouching) return;
    
    const touchY = e.touches[0].clientY;
    const deltaY = touchStartY - touchY;
    touchStartY = touchY;
    
    // Apply improved touch handling
    const currentDirection = Math.sign(deltaY);
    if (currentDirection !== scrollDirection && scrollDirection !== 0) {
      // Direction changed during touch, apply gentler transition
      velocity *= -config.dampingFactor;
    } else {
      // Update velocity for inertial scrolling after touch
      velocity = velocity * 0.7 + (deltaY * config.touchMultiplier * 0.3);
    }
    
    scrollDirection = currentDirection;
    targetY += deltaY * config.touchMultiplier;
    
    // Clamp to valid scroll range
    targetY = Math.max(0, Math.min(targetY, 
      document.documentElement.scrollHeight - window.innerHeight));
    
    if (!frameId) {
      frameId = requestAnimationFrame(render);
    }
  }, { passive: true });
  
  window.addEventListener('touchend', (e) => {
    // DRAWER FIX: Skip handling if the event is within the quick cart or search
    if (isInDrawer(e.target)) {
      return;
    }
    
    isTouching = false;
    // Apply inertial scrolling when touch ends
    if (Math.abs(velocity) > 1) {
      targetY += velocity * 4; // Apply some extra scroll based on final velocity
      
      // Ensure we don't scroll beyond boundaries
      targetY = Math.max(0, Math.min(targetY, 
        document.documentElement.scrollHeight - window.innerHeight));
        
      if (!frameId) {
        frameId = requestAnimationFrame(render);
      }
    }
  }, { passive: true });
  
  // Handle resize properly
  window.addEventListener('resize', () => {
    // If we're at the bottom of the page, stay at bottom after resize
    const isAtBottom = (window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 10;
    
    if (isAtBottom) {
      targetY = document.documentElement.scrollHeight - window.innerHeight;
      currentY = targetY;
    } else {
      // Normal behavior - update scroll position
      targetY = window.scrollY;
      currentY = window.scrollY;
    }
  });
  
  // Render loop - enhanced for natural motion
  function render() {
    // Apply performance optimization
    optimizeForPerformance();
    
    // Calculate the difference and apply friction
    const diff = targetY - currentY;
    
    // Apply enhanced dynamic friction based on distance and velocity
    let dynamicFriction = config.friction;
    
    // Smoother approach to target when getting close
    if (Math.abs(diff) < config.dampingThreshold) {
      // Apply progressive easing as we get closer to target
      const easingRatio = Math.max(0.1, Math.min(1, Math.abs(diff) / config.dampingThreshold));
      dynamicFriction = config.friction * (2 - easingRatio);
    }
    
    // Apply natural easing curve
    const delta = diff * dynamicFriction;
    
    // Check if we should stop the animation
    if (Math.abs(delta) < config.minDelta && Math.abs(diff) < 1) {
      currentY = targetY; // Snap to exact position to avoid micro-movements
      window.scrollTo(0, currentY);
      velocity = 0;
      frameId = null;
      return;
    }
    
    // Apply velocity decay
    velocity *= 0.95;
    
    // Update current position
    currentY += delta;
    
    // Apply the scroll - use transform for hardware acceleration
    window.scrollTo(0, Math.round(currentY));
    
    // Continue the animation
    frameId = requestAnimationFrame(render);
  }
  
  // Initialize scroll position
  targetY = window.scrollY;
  currentY = window.scrollY;
  
  // Custom scroll event for theme compatibility
  window.addEventListener('scroll', () => {
    // Only update target if user manually scrolled (not from our animation)
    if (!frameId && performance.now() - lastScrollTime > 100) {
      targetY = window.scrollY;
      currentY = window.scrollY;
      velocity = 0; // Reset velocity on manual scroll
    }
  }, { passive: true });
  
  // Expose API for potential theme interaction
  window.smoothScroll = {
    scrollTo: (y, instant = false) => {
      if (instant) {
        targetY = y;
        currentY = y;
        velocity = 0;
        window.scrollTo(0, y);
      } else {
        // Apply animated scroll with natural easing
        const distance = Math.abs(y - currentY);
        velocity = (y - currentY) * 0.05; // Set initial velocity based on distance
        targetY = y;
        if (!frameId) {
          frameId = requestAnimationFrame(render);
        }
      }
    }
  };
});